import React, { Fragment } from 'react';
import { TextLink } from '../../components/Link';
import { Logo } from '../../components/Logo';
import { SvgIcon } from '../../components/SvgIcon';
import { MenuEntry } from '../../provider/Typo3Provider/types';

interface LogoContainerProps {
  root?: MenuEntry;
}

const LogoContainer = ({ root }: LogoContainerProps) => (
  <Fragment>
    <TextLink to={root ? root.link : '/'}>
      <Logo>
        <SvgIcon icon="logo_mobile" />
      </Logo>
    </TextLink>
  </Fragment>
);

export default LogoContainer;
